import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function FailedSolutions() {
  return <section className="py-8 md:py-12 px-4 md:px-6" style={{
    backgroundColor: 'var(--bg-deep)'
  }} data-id="element-191">
      <div className="max-w-[680px] mx-auto" data-id="element-192">
        <h2 className="text-xl md:text-3xl font-serif text-[var(--text-heading)] mb-5 md:mb-8 text-center" data-id="element-193">
          Después de atravesar mi propio fuego, descubrí una verdad que la
          religión a veces oculta:
        </h2>

        <div className="space-y-3 md:space-y-5 text-base md:text-lg text-[var(--text-primary)] leading-relaxed" data-id="element-194">
          <p data-id="element-195">
            Dios no permite el desierto para castigarte, sino para{' '}
            <strong className="text-[var(--text-heading)]" data-id="element-196">
              despojarte de lo que te estorba y entregarte lo que Él es.
            </strong>
          </p>

          <p className="mt-4" data-id="element-197">
            He condensado 40 días de intermisión, dolor honesto y reconstrucción
            en una guía digital diseñada para llevarte de la mano a través de
            las 4 fases críticas del desierto:
          </p>

          <div className="grid gap-2 md:gap-3 mt-4" data-id="element-198">
            {['El Inventario de las Cenizas.', 'El Silencio de Operación.', 'El Teorema del Aislamiento.', 'La Arquitectura del Nuevo Mañana.'].map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start gap-3 p-3 md:p-4 bg-[var(--bg-elevated)] rounded border border-[var(--accent)]/20" data-id="element-199">
                <div className="w-5 h-5 rounded-full bg-[var(--accent)]/20 flex items-center justify-center flex-shrink-0 mt-0.5 text-[var(--accent)] text-xs font-bold" data-id="element-200">
                  {i + 1}
                </div>
                <p className="text-[var(--text-heading)] font-medium text-sm md:text-base" data-id="element-201">
                  {item}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}